export default "__VITE_ASSET__CoVbsJ35__"